import DeputiesList from './DeputiesList.container';

export default DeputiesList;
